import './ProjectReadOnlyBadge.scss';
import clsx from 'clsx';
import React, { memo } from 'react';
import { FormattedMessage } from 'src/migration/react-intl';
import { LockIcon } from 'src/modules/common/icons/LockIcon';

type Props = {
  readonly rounded?: boolean;
  readonly fixed?: boolean;
  readonly size?: 'sm' | 'lg';
};

export const ProjectReadOnlyBadge = memo(({ rounded, fixed, size = 'sm' }: Props) => (
  <div className={clsx({
    'bp-project-readonly-badge': true,
    'bp-project-readonly-badge--rounded': rounded,
    'bp-project-readonly-badge--fixed': fixed,
    [`bp-project-readonly-badge--${size}`]: size,
  })}
  >
    <div className="bp-project-readonly-badge__icon">
      <LockIcon/>
    </div>

    <span className="bp-project-readonly-badge__text">
      <FormattedMessage id="common/project/readonly"/>
    </span>
  </div>
));
